<template>
  <div class="sensor-text">

    <span class="radius" :style="`background-color:${color}`"></span>
    <div class="value"><span v-text="value"></span></div>
    <div class="remark">
      <div class="unit"><span v-text="unit"></span></div>
      <div class="name"><span v-text="text"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SensorText',
  props: {
    color: {
      default: 'great'
    },
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String
    },
    text: {
      type: String
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.sensor-text {
  display: flex;
  align-items: flex-start;
  .value {
    font-size: 23px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
  }
  .remark {
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text-left;
    .unit {
      font-size: 8px;
      font-weight: 400;
      color: rgba(137, 137, 137, 1);
    }
    .name {
      font-size: 11px;
      font-weight: 400;
      color: rgba(38, 38, 38, 1);
    }
  }
  .radius, .radius[color=great] {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
    background-color: #32D374;
    margin-top: 5px;
    margin-right: 5px;
  }
  .radius[color=bad] {
    background-color: #E7787E;
  }
  .radius[color=good] {
    background-color: #D4B897;
  }
}
</style>
